module.exports = __webpack_public_path__ + "static/img/sanjidalianligong.b9c7ae2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/sanjidalianligong.png
// module id = tZye
// module chunks = 46